import { useContext } from 'react';
import ChannelContext from '../../components/ChannelContext';
export function useChannelSettings() {
    const context = useContext(ChannelContext);
    const selectedChannelSettings = Object.assign({}, context.selectedChannel.settings);
    // default incVat to true
    if (typeof selectedChannelSettings.pricesIncVat === 'undefined') {
        selectedChannelSettings.pricesIncVat = true;
    }
    return selectedChannelSettings;
}
//# sourceMappingURL=useChannelSettings.js.map